var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5561_18305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 17.5V15.8333C13.3359 14.9493 12.9847 14.1014 12.3596 13.4763C11.7345 12.8512 10.8867 12.5 10.0026 12.5H4.16927C3.28522 12.5 2.43737 12.8512 1.81225 13.4763C1.18713 14.1014 0.835938 14.9493 0.835938 15.8333V17.5M15.0026 6.66667L19.1693 10.8333M19.1693 6.66667L15.0026 10.8333M10.4193 5.83333C10.4193 7.67428 8.92689 9.16667 7.08594 9.16667C5.24499 9.16667 3.7526 7.67428 3.7526 5.83333C3.7526 3.99238 5.24499 2.5 7.08594 2.5C8.92689 2.5 10.4193 3.99238 10.4193 5.83333Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5561_18305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDelete);
export default __webpack_public_path__ + "static/media/profileDelete.6a6392cf87c2ba20eaddf5e7782af206.svg";
export { ForwardRef as ReactComponent };